import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		container: {
			backgroundColor: theme.palette.grey[50]
		},
		label: {
			fontWeight: 600
		},
		areaChip: {
			height: 20,
			fontSize: '0.6rem'
		},
		fieldName: {
			fontFamily: 'monospace'
		},
		valueChip: {
			maxWidth: '100%',
			height: 'auto',
			padding: 6
		}
	} satisfies Record<string, CSSObject>;
};